'use client';

import { useCallback } from 'react';
import { usePathname } from 'next/navigation';
import { useReportWebVitals } from 'next/web-vitals';

const ENDPOINT = '/api/observability/web-vitals';

export function WebVitalsReporter() {
  const pathname = usePathname();

  const reportMetric = useCallback((metric: {
    name: string;
    value: number;
    rating?: string;
    navigationType?: string;
  }) => {
    const body = JSON.stringify({
      name: metric.name,
      value: metric.value,
      rating: metric.rating ?? 'unknown',
      pathname,
      navigationType: metric.navigationType ?? 'other',
    });

    if (navigator.sendBeacon?.(ENDPOINT, new Blob([body], { type: 'application/json' }))) {
      return;
    }

    void fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
      credentials: 'include',
    }).catch(() => undefined);
  }, [pathname]);

  useReportWebVitals(reportMetric);
  return null;
}
